export default __webpack_public_path__ + "static/Feeding_Trough-d94802251d4b9c20eadcd423bdb53cf1.png";